import api from "@/services/api.service";

export default {
    name: "list",
    components: {},
    props: {
        caption: {
            type: String,
            default: "Role List"
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            index: 1,
            mode: "multi",
            icon: 'fa fa-sort',
            selcol: '',
            items: [],
            fields: [
            { key: "#" },
            { key: "role", sortable: false },    
            { key: "permission", sortable: false },
            { key: "actions" }
            ],
            sech: {},
            currentPage: 1,
            currentSortDir:'desc',
            perPage: 10,
            totalRows: null,
            totalUsers: null,
            isBusy: true,
            delete_ids: [],
            allSelected: false,
            colName : '',
            permission_list: false,
            permission_add: false,
            permission_delete: false,
            permission_edit: false,
            superAdmin: false
        };
    },
    computed: {},
    mounted() {},
    async created() {
        let response = await api.post("users/user-permissions");
            const permissions = [];
            if (response.status == "success") {
              response.data[0].permission.forEach( function(element) {                
                  permissions.push(element.action)
              }.bind(this));
              this.permission_list = permissions.includes("list_role");
              this.permission_add = permissions.includes("add_role");
                if(this.permission_list == true || this.permission_add == true){
                    this.getUsers();
                    this.permission_edit = permissions.includes("edit_role");
                    this.permission_delete = permissions.includes("delete_role");  
                }else if(response.data[0].role == 'super_admin'){
                    this.getUsers();
                    this.superAdmin = true;
                }else{
                    this.makeToast("Permission denied","Alert","warning",6000);
                    this.$router.push({name: 'Admin Dashboard'});
                }
            }      
    },
    watch: {
        currentPage: {
            handler: function(page) {                
               // this.getUsers(page);
                this.toSort(this.colName,page);
            }
        }
    },
    methods: {
        makeToast(message = "", title = "Alert", variant = "warning") {
            this.toastCount++;
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            });
        },
        selectAll: function(e) {
            this.delete_ids = [];            
            if(e.target.checked){
                for (var item in this.items) {
                    this.delete_ids.push(this.items[item].id.toString());
                }                
            }            
        },
        selectOne(){
            this.allSelected = false;            
        },
        async toSort (items,page = 1)
        {   
            if (items != "actions" && items != "#" && items != "permission") {                
                if(page == 1)
                if(items == this.colName)
                this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 

                this.colName = items;
                this.isBusy = true;
                let response = await api.post("role-permission/role-list",{ page:page,columnname:items,sortType:this.currentSortDir,paginateVal:this.perPage});
                if (response.status == "success") {
                    if (response.data != "") {
                        if(this.currentSortDir == 'asc'){
                            this.icon1 = 'fa fa-sort-up';                             
                            this.selcol = items;        
                        } else{ 
                            this.icon1 = 'fa fa-sort-down';                             
                            this.selcol = items;
                        }                        
                        this.items = response.data.data;
                        this.totalUsers = response.data.total;
                        this.currentPage = response.data.current_page;
                        this.perPage = response.data.per_page;
                    } else {
                        this.items = [];
                    }
                } else {
                    this.items = [];
                }
               this.isBusy = false;   
            }            
        },

        multipleDelete(){
            this.$bvModal
            .msgBoxConfirm("Are you sure want to delete this roles?")
            .then(value => {
                if (value) {
                    this.deleteRole(this.delete_ids,0);
                } else {
                    return;
                }
            })
            .catch(function() {
                return;
            });

        },
        async getUsers(page) {
            this.sech.page = page;
            let response = await api.post("role-permission/role-list", this.sech);
            if (!response)
                this.makeToast(
                    "Something went to wrong please try again",
                    "Alert",
                    "danger",
                    6000
                    );
            if (response.status == "success") {
                if (response.data != "") {
                    this.items = response.data.data;
                    this.totalUsers = response.data.total;
                    this.currentPage = response.data.current_page;
                    this.perPage = response.data.per_page;
                    
                    this.pageOptions.forEach(element => {
                        if(element.value > this.totalUsers){
                            var indexOf = this.pageOptions.indexOf(element);
                            if( indexOf != 0 )
                            this.pageOptions.splice(indexOf)
                        }
                    });
                    if(this.totalUsers <= 500)
                    this.pageOptions.push({text:'All',value:this.totalUsers});
                } else {
                    this.items = [];
                }
            }else {
               this.items = [];
           }
           this.isBusy = false;
       },
       getRowCount(items) {            
        return items.length;
    },        
    updateRole(id) {
        this.$router.push({ name: "Edit Role", params: { id: id } });
    },
    singleDelete(id, index) {
        this.$bvModal.msgBoxConfirm("Are you sure want to delete this role?").then(value => {
            if (value) {
                this.deleteRole(id, index);
            } 
            else { return; }
        })
        .catch(function() { return;});
    },
    async deleteRole(id, index) {
        console.log(id);
        let response = await api.post("role-permission/delete", {id:id});
        if (!response)
            this.makeToast("Something went to wrong please try again","Alert","danger",6000);

        if (response.status == "success") {
            if(index == 0)
                this.getUsers();
            else
                this.items.splice(index, 1);

            this.makeToast(response.message || `role deleted successful.`,"Alert","success");
        } else
        this.makeToast(`role not deleted.`, "Alert", "danger");
    }
}
};
